// Copyright (C) 2021-Present CITEC Inc. <https://citecsolutions.com/>
// All rights reserved
//
// This file is part of CITEC Inc. source code.
// This software framework contains the confidential and proprietary information
// of CITEC Inc., its affiliates, and its licensors. Your use of these
// materials is governed by the terms of the Agreement between your organization
// and CITEC Inc., and any unauthorized use is forbidden. Except as otherwise
// stated in the Agreement, this software framework is for your internal use
// only and may only be shared outside your organization with the prior written
// permission of CITEC Inc.
// CITEC Inc. source code can not be copied and/or distributed without the express
// permission of CITEC Inc.

import { AccountCurrency } from '@shared/data-access/types/brokerage-types';

/**
 * Map of currency codes to their symbol representations.
 *
 * @readonly
 */
export const CURRENCY_SYMBOL_MAP: ReadonlyMap<string, string> = new Map([
  [AccountCurrency.EUR, '€'],
  [AccountCurrency.USD, '$'],
]);

/**
 * Gets the currency symbol for a given currency code.
 *
 * @example
 *
 * ```ts
 * getCurrencySymbol('EUR'); // Returns '€'
 * getCurrencySymbol('USD'); // Returns '$'
 * getCurrencySymbol('GBP'); // Returns ''
 * ```
 *
 * @param currency - The currency code (e.g., 'EUR', 'USD').
 * @returns The currency symbol (e.g., '€', '$') or an empty string if not found.
 */
export const getCurrencySymbol = (currency?: string): string => {
  if (!currency) {
    return '';
  }
  return CURRENCY_SYMBOL_MAP.get(currency) || '';
};
